module.exports = __webpack_public_path__ + "static/media/newTruckTms.8dfe49c9.png";